<div
  class="u-padding-16-0 u-textAlign-center"
  fxLayout="row"
  fxLayoutGap="8px"
  fxLayoutAlign.lt-sm="center center"
  fxShow.gt-xs="true"
  fxShow="false"
>
  <ng-container
    *ngTemplateOutlet="
      menuItem;
      context: {
        item: {
          label: profileMenuItemLabels.hub.label,
          queryParams: { group: null, mode: null },
        },
      }
    "
  ></ng-container>
  <ng-container *ngIf="(profile.groups | appVisibleGroups)?.length">
    <ng-container
      *ngTemplateOutlet="
        menuItem;
        context: {
          item: {
            label: profileMenuItemLabels.profile.label,
            queryParams: {
              mode: null,
              group: (profile.groups | appVisibleGroups)[0]?.document?.slug,
            },
          },
        }
      "
    ></ng-container>
  </ng-container>
  <ng-container *ngIf="canUserViewScoreCard">
    <ng-container
      *ngTemplateOutlet="
        menuItem;
        context: {
          item: {
            label: profileMenuItemLabels.scorecard.label,
            queryParams: { mode: true },
            url: './scorecard',
          },
        }
      "
    ></ng-container>
  </ng-container>
  <ng-template #menuItem let-item="item">
    <a
      class="u-padding-8 u-borderRadius--4px text-subtitle-2 u-display-block"
      [ngStyle]="{ 'min-width': '60px' }"
      [routerLink]="[item.url ?? '.']"
      [replaceUrl]="true"
      [queryParams]="item.queryParams"
      [routerLinkActiveOptions]="{ exact: true }"
      routerLinkActive="color-blue bg-color-blue--20"
      queryParamsHandling="merge"
    >
      {{ item.label }}
    </a>
  </ng-template>
</div>
